import React from 'react';
import { useTheme } from '../../utils/ThemeSwitcher';
 
const Tabs = ({ tabs, activeTab, onTabChange, isSidePanelExpanded, isMobile = false }) => {
  const { isDarkMode } = useTheme();
 
  return (
    <>
      {/* Mobile: solid background mask from top to cover scroll-through */}
      {isMobile && (
        <div style={{
          position: 'fixed',
          top: '1px',
          left: 0,
          right: 0,
          height: '76px',
          backgroundColor: isDarkMode ? '#0D0E0E' : '#F5F5F5',
          zIndex: 98,
          pointerEvents: 'none',
        }} />
      )}
      <div
        style={{
          display: 'flex',
          position: 'fixed',
          top: isMobile ? '32px' : 0,
          left: isMobile ? 0 : (isSidePanelExpanded ? '10px' : '50px'),
          right: isMobile ? '48px' : 0,
          zIndex: 99,
          justifyContent: isMobile ? 'flex-start' : 'center',
          alignItems: 'center',
          paddingBottom: isMobile ? '6px' : '6px',
          paddingLeft: isMobile ? '12px' : '24px',
          paddingRight: isMobile ? '4px' : '24px',
          overflowX: 'auto',
          WebkitOverflowScrolling: 'touch',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
        }}
      >
      <nav style={{
        display: 'flex',
        gap: '2px',
        flexWrap: 'nowrap',
        flexShrink: 0,
        justifyContent: isMobile ? 'flex-start' : 'center',
        /* Near-opaque page-colored backdrop stays — it masks content
           scrolling underneath this floating bar. */
        backgroundColor: isDarkMode ? 'rgba(13, 14, 14, 0.95)' : 'rgba(245, 245, 245, 0.95)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        borderRadius: '11px',
        padding: '3px',
        border: `1px solid ${isDarkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.07)'}`,
      }}>
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
 
          return (
            <button
              key={tab.id}
              className={`dq-topnav-tab${isActive ? ' active' : ''}`}
              onClick={() => onTabChange(tab.id)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: isMobile ? '5px' : '8px',
                padding: isMobile ? '7px 10px' : '6px 13px',
                border: 'none',
                borderRadius: '8px',
                backgroundColor: isActive
                  ? (isDarkMode ? '#17181a' : '#FFFFFF')
                  : 'transparent',
                color: isActive
                  ? (isDarkMode ? '#ececec' : '#1a1a1a')
                  : (isDarkMode ? '#6d7178' : '#8a8f98'),
                boxShadow: isActive
                  ? (isDarkMode
                      ? '0 1px 2px rgba(0,0,0,0.4)'
                      : '0 1px 2px rgba(0,0,0,0.08), 0 1px 6px rgba(0,0,0,0.06)')
                  : 'none',
                cursor: 'pointer',
                fontSize: '12px',
                fontWeight: isActive ? 600 : 500,
                transition: 'color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease',
                whiteSpace: 'nowrap',
                flexShrink: 0,
                minHeight: isMobile ? '32px' : 'auto',
                WebkitTapHighlightColor: 'transparent',
                fontFamily: "'Outfit', -apple-system, BlinkMacSystemFont, sans-serif",
              }}
            >
              <Icon size={14} strokeWidth={1.75} />
              <span>{tab.name}</span>
            </button>
          );
        })}
      </nav>
      <style>{`
        .dq-topnav-tab:not(.active):hover {
          color: ${isDarkMode ? '#a5a9b0' : '#55595f'} !important;
        }
        .dq-topnav-tab:focus-visible {
          outline: 2px solid #2563EB;
          outline-offset: 2px;
        }
      `}</style>
      {isMobile && (
        <style>{`
          div[style*="top: 32px"][style*="overflow"] { scrollbar-width: none !important; }
          div[style*="top: 32px"][style*="overflow"]::-webkit-scrollbar { display: none !important; }
        `}</style>
      )}
    </div>
    </>
  );
};
 
export default Tabs;